import 'shepherd.js/dist/css/shepherd.css'
import Shepherd from 'shepherd.js'
import { createTour } from './tour'
import { CTABasicSetupConfig } from './CTABasicSetup'
import { CTAIVRSetupConfig } from './CTAIVRSetup'
import { CTAQueueSetupConfig } from './CTAQueueSetup'
import { CFCBasicSetupConfig } from './CFCBasicSetup'
import { CTANightSwitchSetupConfig } from './CTANightSwitchSetup'
import { CTAExtendedForwardingSetupConfig } from './CTAExtendedForwardingSetup'
import { CTAImportPopupConfig } from './CTAImportPopup'

const steps = {
  CTABasicSetup: CTABasicSetupConfig,
  CTAIVRSetup: CTAIVRSetupConfig,
  CFCBasicSetup: CFCBasicSetupConfig,
  CTAQueueSetup: CTAQueueSetupConfig,
  CTANightSwitchSetup: CTANightSwitchSetupConfig,
  CTAExtendedForwardingSetup: CTAExtendedForwardingSetupConfig,
  CTAImportPopup: CTAImportPopupConfig,
}

const tours: Partial<Record<string, Shepherd.Tour>> = {}

/**
 * Creates, caches and returns Shepherd.Tour instances
 */
export function getTour(name: keyof typeof steps) {
  if (!tours[name]) {
    tours[name] = createTour(steps[name])
  }

  return tours[name]
}

export function cancelCurrentTour() {
  Shepherd.activeTour?.cancel()
}
